import { BaseService } from '@estee/elc-service';
import { ServiceInitializer } from '@estee/elc-universal-utils';

const { name, version } = __serviceInfo__;

export class LoyaltyService extends BaseService {
    constructor(serviceInitializer: ServiceInitializer) {
        super(name, version, serviceInitializer);
    }
}

export default {
    authenticatedRepository: 'AUTHENTICATED_REPOSITORY',
    businessUnitIdParser: 'BUSINESS_UNIT_ID_PARSER',
    config: 'CONFIG',
    configRepository: 'CONFIG_REPOSITORY',
    dateFormatter: 'DATE_FORMATTER',
    httpTransport: 'HTTP_TRANSPORT',
    loyaltyApiSdk: 'LOYALTY_API_SDK',
    loyaltyRpcAPI: 'LOYALTY_RPC_API',
    loyaltyInfo: 'LOYALTY_INFO',
    loyaltyPointsInfoController: 'LOYALTY_POINTS_INFO_CONTROLLER',
    loyaltyRepository: 'LOYALTY_REPOSITORY',
    loyaltyService: 'LOYALTY_SERVICE',
    loyaltyTierInfoController: 'LOYALTY_TIER_INFO_CONTROLLER',
    loyaltyTierViewController: 'LOYALTY_TIER_VIEW_CONTROLLER',
    loyaltyDashboardViewController: 'LOYALTY_DASHBOARD_VIEW_CONTROLLER',
    loyaltySubmitAReceiptController: 'LOYALTY_SUBMIT_A_RECEIPT_CONTROLLER',
    loyaltyPointsHistoryController: 'LOYALTY_POINTS_HISTORY_CONTROLLER',
    loyaltyEarnPointsController: 'LOYALTY_EARN_POINTS_CONTROLLER',
    loyaltyBenefitsController: 'LOYALTY_BENEFITS_CONTROLLER',
    loyaltyRewardsController: 'LOYALTY_REWARDS_CONTROLLER',
    loyaltyPointBenefitController: 'LOYALTY_POINT_BENEFIT_CONTROLLER',
    loyaltyBirthdayController: 'LOYALTY_BIRTHDAY_CONTROLLER',
    logger: 'logger',
    numberFormatter: 'NUMBER_FORMATTER',
    queryFragments: 'QUERY_FRAGMENTS',
    serviceBusController: 'SERVICE_BUS_CONTROLLER',
    loyaltyMarketingPageController: 'LOYALTY_MARKETING_PAGE_CONTROLLER',
    loyaltyLandingPageController: 'LOYALTY_LANDING_PAGE_CONTROLLER',
    siteConfig: 'SITE_CONFIG'
};
